import { useEffect, useRef } from "react";

interface SandboxedRendererProps {
  html: string;
}

export function SandboxedRenderer({ html }: SandboxedRendererProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const doc = iframe.contentDocument;
    if (!doc) return;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data: https:;">
        <style>
          body { margin: 0; padding: 16px; font-family: system-ui, -apple-system, sans-serif; font-size: 14px; color: #1a1a1a; }
          * { box-sizing: border-box; }
        </style>
      </head>
      <body>${html}</body>
      </html>
    `);
    doc.close();
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      sandbox="allow-same-origin"
      title="Canvas output"
      className="h-full min-h-[200px] w-full rounded-lg border border-puntt-neutral-gray-5"
    />
  );
}
